"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.provider.stripe.description': 'Paga con carte di credito, debito e portafogli digitali usando Stripe',
};
